'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCropFree = function MdCropFree(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 5c1.8 0 3.4 1.6 3.4 3.4v6.6h-3.4v-6.6h-6.6v-3.4h6.6z m0 26.6v-6.6h3.4v6.6c0 1.8-1.6 3.4-3.4 3.4h-6.6v-3.4h6.6z m-23.2-6.6v6.6h6.6v3.4h-6.6c-1.8 0-3.4-1.6-3.4-3.4v-6.6h3.4z m-3.4-16.6c0-1.8 1.6-3.4 3.4-3.4h6.6v3.4h-6.6v6.6h-3.4v-6.6z' })
        )
    );
};

exports.default = MdCropFree;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/crop-free.js
// module id = ./node_modules/react-icons/lib/md/crop-free.js
// module chunks = 0